import React from 'react';
import { CtaButton } from './CtaButton';
import { heroBadges } from '../data/content';
export function Hero() {
  return <header className="w-full bg-[#0a0a0a] px-5 pb-8 pt-6 text-white sm:px-8 sm:pt-8" data-id="element-140" data-mp="ej4n3wauu9ex">
      <div className="mx-auto flex w-full max-w-3xl flex-col items-center text-center" data-id="element-141" data-mp="9lv0eoeuobus">
        <p className="text-sm font-extrabold tracking-wide text-[#7c3aed] sm:text-base" data-id="element-142" data-mp="4mi297ij3icw">
          🏐 NETBALL READY 360
        </p>

        <p className="mt-2.5 rounded-full border border-[#7c3aed]/40 bg-[#7c3aed]/10 px-3 py-1 text-[10px] font-bold uppercase tracking-wide text-[#a78bfa] sm:text-[11px]" data-id="element-143" data-mp="128yz6bncnty4">
          🏐 Trusted by hundreds of coaches worldwide
        </p>

        <h1 className="mt-3 text-2xl font-extrabold leading-[1.08] tracking-tight sm:text-3xl md:text-4xl" data-id="element-144" data-mp="nc87kojx3mj2">
          Plan Your Entire Netball Season{' '}
          <span className="text-[#7c3aed]" data-id="element-145" data-mp="3d33gp3txj3ne">In Under 5 Minutes.</span>
        </h1>

        <p className="mt-3 max-w-xl text-xs leading-snug text-neutral-400 sm:text-sm" data-id="element-146" data-mp="381e0l9runzsg">
          The complete netball bible for coaches and PE teachers — 200+ sessions, 101
          shooting and feeding drills, tactics, planning tools and more. Everything done
          for you.
        </p>

        <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-bold sm:text-xs" data-id="element-147" data-mp="399b9pjftv5tv">
          {heroBadges.map(badge => <li key={badge} className="flex items-center gap-1" data-id="element-148" data-mp="30i19586e29fo">
              <span aria-hidden="true" data-id="element-149" data-mp="30gq3t3xaotmg">✅</span>
              {badge}
            </li>)}
        </ul>

        <img src="https://cdn.magicpatterns.com/uploads/fWT65vEuJQGvmVVBbnbpKT/Netball_mockup.png" alt="Netball Ready 360 complete bundle: 6 volumes, tablet, desktop, phone and coaching kit" className="mt-4 max-h-[38vh] w-full max-w-md object-contain sm:max-h-[42vh]" data-id="element-150" data-mp="35aueny9ollst" />

        <div className="mt-4 w-full max-w-md" data-id="element-151" data-mp="2hlj9m4lat58v">
          <CtaButton className="!py-3.5 !text-base sm:!text-lg" data-id="element-152" data-mp="2ljpa4uvjmolc" />
        </div>

        <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] text-neutral-300 sm:text-xs" data-id="element-153" data-mp="s2joa067q6l3">
          <li data-id="element-154" data-mp="najhbnrq6df0">🔒 Secure Payment</li>
          <li data-id="element-155" data-mp="n9i53fyz3kvp">⚡ Instant Access</li>
          <li data-id="element-156" data-mp="ibowkga76es9">🛡️ 7-Day Guarantee</li>
        </ul>
      </div>
    </header>;
}